class ExpandingAnchorBtn extends HTMLAnchorElement {
    get btnIcon() {
        return this.getAttribute('btn-icon');
    }

    set btnIcon(val) {
        if (val) {
            this.setAttribute('btn-icon', val);
        } else {
            this.removeAttribute('btn-icon');
        }
        this.format();
    }


    static get observedAttributes() {
        return ['btn-style'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        this.btnStyle = newValue;
    }

    format(){
        this.innerHTML = "<span class='btn-inside'>"+this.textContent+(this.btnIcon?'<i role="presentation" class="icon icon-'+this.btnIcon+'"></i>':'')+"</span>";
    }

    connectedCallback(){
        this.format();
    }

    disconnectedCallback(){
        this.format();
    }
    constructor() {
        // Always call super first in constructor
        super();

        // write element functionality in here
    }
}
customElements.define('exp-a', ExpandingAnchorBtn, {extends: 'a'});
class ExpandingButtonBtn extends HTMLButtonElement {

    get btnIcon() {
        return this.getAttribute('btn-icon');
    }

    set btnIcon(val) {
        if (val) {
            this.setAttribute('btn-icon', val);
        } else {
            this.removeAttribute('btn-icon');
        }
        this.format();
    }


    static get observedAttributes() {
        return ['btn-style'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        this.btnStyle = newValue;
    }

    format(){
        this.innerHTML = "<span class='btn-inside'>"+this.textContent+(this.btnIcon?'<i  role="presentation" class="icon icon-'+this.btnIcon+'"></i>':'')+"</span>";
    }

    connectedCallback(){
        this.format();
    }

    disconnectedCallback(){
        this.format();
    }
    constructor() {
        // Always call super first in constructor
        super();

        // write element functionality in here
    }
}
customElements.define('exp-btn', ExpandingButtonBtn, {extends: 'button'});

class ToggleButton extends HTMLElement {

    get for(){
        return this.getAttribute('for');
    }
    get activeTest(){
        return this.hasAttribute('active-test');
    }
    get group(){
        return this.hasAttribute('group');
    }
    get animation(){
        return this.getAttribute('animation');
    }
    get open() {
        return this.hasAttribute('open');
    }

    get hover(){
        return this.hasAttribute('hover');
    }
    set open(val) {
        val? this.setAttribute('open', '') : this.removeAttribute('open');
        this.group? this.toggleGroup() : this.toggleContent();
        let s;
        s = document.querySelector('#' + this.for + ' [name="q"]');

        if(s !==null){

            setTimeout(function (){s.focus();},100);
        }
    }
    set activeTest(val) {
        if (val) {
            this.setAttribute('active-test', '');
            this.click();
        } else {
            this.removeAttribute('active-test');
        }
    }

    get fade(){
        return this.hasAttribute('fade');
    }

    static get observedAttributes() {
        return [];
    }

    attributeChangedCallback(name, oldValue, newValue) {}

    toggleContent(){
        this.setAttribute('aria-expanded', (this.open?'true':'false'));
        if(this.open){
            this.fade && document.dispatchEvent(new CustomEvent('fade:click',{detail:this}));
            this.content.classList.add('active');
            this.classList.add('active');
            this.animation === 'slide' && this.slideDown();
            this.fade && document.querySelector('body').classList.add('btn-fade-toggle-'+this.for);

        } else {
            this.content.classList.remove('active');
            this.classList.remove('active');
            this.animation === 'slide' && this.slideUp();
            this.fade && document.querySelector('body').classList.remove('btn-fade-toggle-'+this.for);
        }
    }
    toggleOpen(){
        this.open = !this.open;
    }
    toggleGroup(){
        [... this.parentElement.children].forEach((e)=>{
            let content = document.querySelector('#' + e.for);

            if(e==this){
                if(content)
                content.classList.add('active');
                this.classList.add('active');
                this.setAttribute('aria-expanded', 'true');
                localStorage.setItem('toggle-'+this.getAttribute('group'),this.getAttribute('id'));
            } else {
                if(content)
                    content.classList.remove('active');
                e.classList.remove('active');
                this.setAttribute('aria-expanded', 'false');
            }
        });
    }
    over(){
        this.open = true;
    }
    slideDown(){
        this.content.style.maxHeight = this.content.querySelector('.toggle-wrap').offsetHeight+'px';
    }
    slideUp(){
        this.content.style.maxHeight = 0;
    }
    close(e){
        if(e.detail !== this) this.open = false;
    }
    connectedCallback(){
        if(this.group) {
            this.addEventListener('click', this.toggleGroup);
            if(this.activeTest && !localStorage.getItem('toggle-'+this.getAttribute('group')))
                this.click();

            if(localStorage.getItem('toggle-'+this.getAttribute('group')) && this.getAttribute('group') === 'mobile_menu' && localStorage.getItem('toggle-'+this.getAttribute('group')) === this.getAttribute('id')){
                this.click();
            }



        } else{
            this.setAttribute('role', 'button');
            this.content = document.querySelector('#' + this.for);
            this.content.setAttribute('animation', this.animation);
            this.content.classList.add('target-content');
            this.content.innerHTML = '<div class="toggle-wrap">' + this.content.innerHTML + '</div>';
            this.addEventListener('click', this.toggleOpen);
            this.toggleContent();
            this.fade && document.addEventListener('fade:click', this.close);
            this.hover && document.addEventListener('mouseenter', this.over);

        }

        this.setAttribute('tabindex','0');
    }

    disconnectedCallback(){
        this.removeEventListener('click',this.toggleContent);
        this.fade && document.removeEventListener('fade:click',this.close);
        this.hover && document.removeEventListener('mouseenter',this.over);
    }
    constructor() {
        // Always call super first in constructor
        super();
        this.toggleOpen = this.toggleOpen.bind(this);
        this.close = this.close.bind(this);
        this.over = this.over.bind(this);
        this.toggleGroup = this.toggleGroup.bind(this);
        // write element functionality in here
    }
}
customElements.define('button-toggle', ToggleButton);

